import urls from '../constants/urls'

export const LOADING_OPTIONS = 'numbersCopy/LOADING_OPTIONS'
export const OPTIONS_LOAD_SUCCESS = 'numbersCopy/OPTIONS_LOAD_SUCCESS'
export const OPTIONS_LOAD_FAILED = 'numbersCopy/OPTIONS_LOAD_FAILED'

export const COPY_NUMBERS_FAILED = 'numbersCopy/COPY_NUMBERS_FAILED'
export const COPY_NUMBERS_SUCCESS = 'numbersCopy/COPY_NUMBERS_SUCCESS'
export const COPYING_NUMBERS = 'numbersCopy/COPYING_NUMBERS'

const initialState = {
  options: [],

  failedLoading: false,
  isLoading:     false
}

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_OPTIONS:
      return {
        ...state,
        failedLoading: false,
        isLoading:     true
      }

    case OPTIONS_LOAD_SUCCESS:
      return {
        ...state,
        options: action.payload.data
      }

    case OPTIONS_LOAD_FAILED:
      return {
        ...state,
        failedLoading: true,
        isLoading:     false
      }

    case COPYING_NUMBERS:
      return {
        ...state,
        failedCopy: false,
        isCopying:  true
      }

    case COPY_NUMBERS_SUCCESS:
      return {
        ...state,
        isCopying: false
      }

    case COPY_NUMBERS_FAILED:
      return {
        ...state,
        failedCopy: true,
        isCopying:  false
      }

    default:
      return state
  }
}

export const loadOptions = (hospitalId) => (dispatch) => {
  return dispatch({
    types:   [LOADING_OPTIONS, OPTIONS_LOAD_SUCCESS, OPTIONS_LOAD_FAILED],
    payload: {
      request: {
        method: 'get',
        url:    urls.hospitals.numbersCopy.new(hospitalId)
      }
    }
  })
}

export const copyNumbers = (hospitalId, params) => (dispatch) => {
  return dispatch({
    types:   [COPYING_NUMBERS, COPY_NUMBERS_SUCCESS, COPY_NUMBERS_FAILED],
    payload: {
      request: {
        method: 'post',
        url:    urls.hospitals.numbersCopy.create(hospitalId),
        data:   params
      }
    }
  })
}
